export const USER_ARI_PREFIX = 'ari:cloud:identity::user/';
export const TEAM_ARI_PREFIX = 'ari:cloud:identity::team/';